"use strict";

/**
 * PageBreaks
 */
var _classCallCheck = require("/builds/sis-cc/.stat-suite/dotstatsuite-data-explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/builds/sis-cc/.stat-suite/dotstatsuite-data-explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var PageBreaks = /*#__PURE__*/function () {
  function PageBreaks(node) {
    _classCallCheck(this, PageBreaks);
    this._node = node;
  }

  /**
   * add page-breaks by row/column id
   * @param {number} id - row/column id (rowNumber/colNumber)
   * @return {PageBreaks} the page-breaks
   */
  return _createClass(PageBreaks, [{
    key: "add",
    value: function add(id) {
      this._node.children.push({
        name: "brk",
        children: [],
        attributes: {
          id: id,
          max: 16383,
          man: 1
        }
      });
      this._node.attributes.count++;
      this._node.attributes.manualBreakCount++;
      return this;
    }

    /**
     * remove page-breaks by index
     * @param {number} index - index of list
     * @return {PageBreaks} the page-breaks
     */
  }, {
    key: "remove",
    value: function remove(index) {
      var brk = this._node.children[index];
      if (brk) {
        this._node.children.splice(index, 1);
        this._node.attributes.count--;
        if (brk.man) {
          this._node.attributes.manualBreakCount--;
        }
      }
      return this;
    }

    /**
     * get count of the page-breaks
     * @return {number} the page-breaks' count
     */
  }, {
    key: "count",
    get: function get() {
      return this._node.attributes.count;
    }

    /**
     * get list of page-breaks
     * @return {Array} list of the page-breaks
     */
  }, {
    key: "list",
    get: function get() {
      return this._node.children.map(function (brk) {
        return {
          id: brk.id,
          isManual: !!brk.man
        };
      });
    }
  }]);
}();
module.exports = PageBreaks;